import { connect } from 'react-redux';
import KYCSumSubLevelsComponent from './KYCSumSubLevelsComponent';
import { kycVerificationLevelsSelector } from '@alphapoint/apex-web/lib/redux/selectors/kycLevelsSelectors';

const mapStateToProps = (state) => {
  const kycData = kycVerificationLevelsSelector(state);
  const { verificationLevel, levelIncreaseStatus, kycConfig } = kycData;

  return {
    highlightStyle: kycConfig.highlightStyle,
    verificationLevel,
    levelIncreaseStatus,
  };
};

const KYCSumSubLevelsContainer = connect(mapStateToProps)(KYCSumSubLevelsComponent);

export default KYCSumSubLevelsContainer;
